/**
 * Compact bill status labels for Pro mobile cards and detail headers.
 * Colorado statuses are often long free-form strings; this maps them to short,
 * realistic stage names users recognize at a glance.
 */
export function formatBillStatusShort(status: string | undefined | null): string {
  const trimmed = (status || '').trim();
  if (!trimmed) return 'Unknown';

  const lower = trimmed.toLowerCase();

  if (/\bsigned\b|became law/.test(lower)) return 'Signed';
  if (/vetoed/.test(lower)) return 'Vetoed';
  if (/postponed indefinitely|failed|killed|\bdied\b/.test(lower)) return 'Failed';
  if (/governor|sent to governor/.test(lower)) return 'With governor';

  if (/passed/.test(lower)) {
    const stage = lower.split(/\s+-\s+/)[0] || lower;
    if (/senate/.test(stage)) return 'Passed Senate';
    if (/house/.test(stage)) return 'Passed House';
    return 'Passed';
  }

  if (/assigned to|committee|hearing|\brefer/.test(lower)) return 'In committee';

  if (/introduced/.test(lower)) {
    if (/house/.test(lower)) return 'Introduced in House';
    if (/senate/.test(lower)) return 'Introduced in Senate';
    return 'Introduced';
  }

  if (/amendment/.test(lower)) return 'Amended';
  if (/laid over/.test(lower)) return 'Laid over';

  if (trimmed.length <= 28) return trimmed;
  return `${trimmed.slice(0, 25).trimEnd()}…`;
}

/** @deprecated Use {@link formatBillStatusShort} — returns a one-element array for legacy callers. */
export function splitBillStatus(status: string | undefined | null): string[] {
  const short = formatBillStatusShort(status);
  return short ? [short] : [];
}
